// @copyright  2026 West Indies Software Engineering Company Limited. All rights reserved.

import bankRulesApi from '@/api/banking/bank-rules.js';

export default {
    namespaced: true,

    state: {
        rules: [],
        page: { number: 1, size: 25, total: 0, count: 0 },
        activeRule: null,
        preview: null,
        loading: false,
    },

    mutations: {
        setRules(state, rules) {
            state.rules = rules;
        },

        setPage(state, page) {
            state.page = {
                number: page?.number ?? 1,
                size: page?.size ?? 25,
                total: page?.total ?? 0,
                count: page?.count ?? 0,
            };
        },

        setActive(state, rule) {
            state.activeRule = rule;
        },

        setPreview(state, preview) {
            state.preview = preview;
        },

        setLoading(state, loading) {
            state.loading = !!loading;
        },

        reset(state) {
            state.rules = [];
            state.page = { number: 1, size: 25, total: 0, count: 0 };
            state.activeRule = null;
            state.preview = null;
            state.loading = false;
        },
    },

    actions: {
        async fetchAll({ commit }, filters = {}) {
            commit('setLoading', true);
            try {
                const response = await bankRulesApi.list(filters);
                commit('setRules', response.data.bankRules ?? []);
                commit('setPage', response.meta?.page ?? {});
            } finally {
                commit('setLoading', false);
            }
        },

        async fetchOne({ commit }, id) {
            const response = await bankRulesApi.view(id);
            commit('setActive', response.data.bankRule ?? null);
        },

        async create({ dispatch }, payload) {
            await bankRulesApi.create(payload);
            await dispatch('fetchAll');
        },

        async update({ dispatch }, { id, payload }) {
            await bankRulesApi.update(id, payload);
            await dispatch('fetchAll');
        },

        async archive({ dispatch }, id) {
            await bankRulesApi.archive(id);
            await dispatch('fetchAll');
        },

        async reorder({ dispatch }, orderedIds) {
            await bankRulesApi.reorder(orderedIds);
            await dispatch('fetchAll');
        },

        async bulkUpdate({ dispatch }, { ids, action }) {
            await bankRulesApi.bulkUpdate(ids, action);
            await dispatch('fetchAll');
        },

        async preview({ commit }, payload) {
            const response = await bankRulesApi.preview(payload);
            commit('setPreview', response.data ?? null);
        },
    },
};
